/* eslint func-names: "off" */
import axios from 'axios';
import store from '../../store';

let baseURL = window.location.origin;

if (process.env.VUE_APP_ORIGIN) {
  baseURL = process.env.VUE_APP_ORIGIN;
}

// Add a response interceptor
axios.interceptors.response.use(response => response, async (error) => {
  if (error.response.status === 401) {
    await store.dispatch('destoryCurrentUser');
    window.location.href = `${baseURL}/accounts/byteark`;
  }
  return Promise.reject(error);
});

export default axios;
